/*
 * Country / province selector shim
 * ---------------------------------
 * theme.js calls `new Shopify.CountryProvinceSelector(...)` inside its _init,
 * which runs on every page. The legacy `shopify_common.js` that defines that
 * constructor is only loaded on the account addresses page, so on every other
 * page the call throws a TypeError and aborts the rest of _init.
 *
 * This shim defines the constructor (and postLink) only if they are missing,
 * using the data-provinces attributes that Shopify's all_country_option_tags
 * already renders. If shopify_common.js does load and defines them, this
 * does nothing at all.
 *
 * Must be loaded BEFORE assets/theme.js.
 */
(function () {
  window.Shopify = window.Shopify || {};

  if (typeof window.Shopify.CountryProvinceSelector !== 'function') {
    window.Shopify.CountryProvinceSelector = function (countryId, provinceId, options) {
      var countryEl = document.getElementById(countryId);
      var provinceEl = document.getElementById(provinceId);
      if (!countryEl || !provinceEl) return;

      var opts = options || {};
      var hideEl = opts.hideElement ? document.getElementById(opts.hideElement) : provinceEl.parentNode;

      function buildProvinces() {
        var selected = countryEl.options[countryEl.selectedIndex];
        var raw = selected ? selected.getAttribute('data-provinces') : null;
        var provinces = [];

        if (raw) {
          try { provinces = JSON.parse(raw); } catch (e) { provinces = []; }
        }

        provinceEl.innerHTML = '';

        if (provinces.length === 0) {
          if (hideEl) hideEl.style.display = 'none';
          return;
        }

        var wanted = provinceEl.getAttribute('data-default') || '';
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement('option');
          opt.value = provinces[i][0];
          opt.textContent = provinces[i][1];
          if (wanted && (wanted === provinces[i][0] || wanted === provinces[i][1])) {
            opt.selected = true;
          }
          provinceEl.appendChild(opt);
        }

        if (hideEl) hideEl.style.display = '';
      }

      var defaultCountry = countryEl.getAttribute('data-default');
      if (defaultCountry) {
        for (var j = 0; j < countryEl.options.length; j++) {
          if (countryEl.options[j].value === defaultCountry) {
            countryEl.selectedIndex = j;
            break;
          }
        }
      }

      countryEl.addEventListener('change', buildProvinces);
      buildProvinces();
    };
  }

  if (typeof window.Shopify.postLink !== 'function') {
    window.Shopify.postLink = function (path, options) {
      options = options || {};
      var method = options.method || 'post';
      var params = options.parameters || {};
      var form = document.createElement('form');
      form.method = method;
      form.action = path;

      Object.keys(params).forEach(function (key) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = params[key];
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    };
  }
})();
